import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const TrackingContext = createContext({});

const TrackingContextProvider = ({ children, isCrawler = false, experimentId }) => {
  const [state, setState] = useState({ isCrawler, experimentId });

  useEffect(() => {
    if (isCrawler) {
      return;
    }

    const touchId =
      localStorage.getItem('touch_id') ??
      Math.random()
        .toString(36)
        .substring(2, 15);

    const searchId = `${touchId}_${Date.now()}`;

    if (!localStorage.getItem('touch_id')) {
      localStorage.setItem('touch_id', touchId);
    }

    setState({ ...state, searchId, experimentId });
  }, []);

  return <TrackingContext.Provider value={[state, setState]}>{children}</TrackingContext.Provider>;
};

TrackingContextProvider.propTypes = {
  children: PropTypes.node,
  isCrawler: PropTypes.bool,
  experimentId: PropTypes.string
};

export { TrackingContext, TrackingContextProvider };
